import React, {useEffect, useState} from "react"
import {Form} from "react-bootstrap"
import {Controller, useForm} from "react-hook-form";
import {useNavigate} from "react-router";
import {notification} from "antd";
import SelectField from "../../../components/common/select-field/SelectField";
import ThemeButton from "../../../components/common/theme-button/ThemeButton";
import DescriptionField from "../../../components/common/description-field/DescriptionField";
import {CloseRoundedCheck, RoundedCheck} from "../../../../assets/icons/defaultIcons";
import {checkEmptySpaces, maxLength, Required} from "../../../utils/patterns";
import {AddGoals} from "../../../services/goals";


export default function AddAnnualGoals({close, getListing, setGetListing, goalSelectedCategroy, setGoalSelectedCategory, setUpdateGoals , updateGoals, duplicateData, year}) {
    const[loader,setLoader] = useState(false);
    const[question,setQuestion] = useState(false);

    console.log('AddAnnualGoals received duplicateData:', duplicateData);
    console.log('AddAnnualGoals received year:', year);

    const {
        handleSubmit,
        reset,
        formState: {errors, isValid},
        control,
        setValue,
        watch
    } = useForm({
        mode: 'onChange',
        defaultValues: {
            des: '',
            category: ''
        }
    })
    const navigate = useNavigate()

    const questionPayload = {
        category: 'gratitude',
    }


    const onSubmit = async (data) => {
        setLoader(true)

        if(data){
            let payload = {
                goal:data.des,
                category: data.category,
                year: year
            }

            const response = await AddGoals(payload)

            if (response?.data?.data?.status){
                notification.success({
                    message: "Success",
                    description: "Goal added Successfully",
                    placement: "topRight",
                    icon: <RoundedCheck/>,
                    duration: 2,
                });
                setLoader(false)
                setUpdateGoals(!updateGoals)
                reset()
                close(false)
            }
            else{
                setLoader(false)
                notification.error({
                    message: "Failed",
                    description: "Goal Failed to Add",
                    placement: "topRight",
                    icon: <CloseRoundedCheck/>,
                    duration: 2,
                });
            }

        }

    }

    // Handle duplicate data population
    useEffect(() => {
        if (duplicateData) {
            console.log('Processing duplicate data in annual goals:', duplicateData);
            // Reset form with duplicate data
            reset({
                des: duplicateData.goal || '',
                category: duplicateData.category || ''
            });
            
            if (duplicateData.category) {
                console.log('Setting goal category:', duplicateData.category);
                setGoalSelectedCategory(duplicateData.category);
            }
        } else {
            console.log('No duplicate data - resetting form');
            // Reset form when no duplicate data
            reset({
                des: '',
                category: ''
            });
        }
    }, [duplicateData, reset, setGoalSelectedCategory]);

    const categorySelect = [
        { value: "Faith", label: "Faith" },
        { value: "Family", label: "Family" },
        { value: "Fitness", label: "Fitness" },
        { value: "Finance", label: "Finance" },
        { value: "Others", label: "Others" },
        { value: "Books", label: "Books" }
    ];

    const hello = watch("category")

    useEffect(()=>{
        console.log(hello, 'hello')
    },[hello])


    return(
        <div className={'add-gratitude'}>
            <Form onSubmit={handleSubmit(onSubmit)}>
                <div className={"dfields"}>
                        <Controller
                            name="category"
                            control={control}
                            rules={{ required:Required }}
                            render={({ field }) => (
                            <SelectField
                                showSearch={false}
                                label={"Category"}
                                field={field}
                                value={field.value}
                                placeholder={"Select Category"}
                                className={"required"}
                                options={categorySelect}
                                fieldName={field.name}
                                setValue={setValue}
                                errors={errors.category}
                            />
                            )}
                        />
                        </div>
                <div className={'dfields'}>
                    <Controller
                        name="des"
                        control={control}
                        rules={{required:Required, maxLength: maxLength(2000) , validate:checkEmptySpaces}}
                        render={({field: {name, ...field}}) => (
                            <DescriptionField
                                placeholder={'Write your goal here'}
                                type={'text'}
                                field={field}
                                errors={errors.des}
                                autoSize={{ minRows: 1, maxRows: 1 }}
                                label={'Write your goal'}
                            />
                        )}
                    />
                </div>
                <div className={'mt-30'}>
                    <ThemeButton
                        text={'Submit'}
                        type={'submit'}
                        className={'btn-light-lg'}
                        loader={loader}
                    />
                </div>
            </Form>
        </div>
    )
}